import {DBxEvent, Extent} from "cartovista";
import {imagerieCopyrights} from "./ImagerieCopyrights";
import carte from "../../../images/basemaps/carte.png";
import hybrid from "../../../images/basemaps/hybrid.png";
import imagerie from "../../../images/basemaps/imagerie.png";
import sobre from "../../../images/basemaps/sobre.png";
import "../../../css/BasemapToggle.css";

    var copyrightImagerieContainer = '<span id="Copyrights_imagerie"></span>';

    var carteSelectBtn = '<div class="BasemapToggle_selectBtnContainer">' +
                            '<span class="BasemapToggle_basemapTitle">Carte</span>' +
                            '<button id="BasemapToggle_carteBtn" class="BasemapToggle_selectBtn" style="background:url(' + carte + ');" title="Afficher le fond carte"></button>' +
                            '<p>Carte</p>' +
                        '</div>';

    var hybridSelectBtn = '<div class="BasemapToggle_selectBtnContainer">' +
                            '<span class="BasemapToggle_basemapTitle">Hybride</span>' +
                            '<button id="BasemapToggle_hybridBtn" class="BasemapToggle_selectBtn" style="background:url(' + hybrid + ');" title="Afficher le fond hybride"></button>' +
                            '<p>Hybride</p>' +
                        '</div>';

    var imagerieSelectBtn = '<div class="BasemapToggle_selectBtnContainer">' +
                                '<span class="BasemapToggle_basemapTitle">Imagerie</span>' +
                                '<button id="BasemapToggle_imagerieBtn" class="BasemapToggle_selectBtn" style="background:url(' + imagerie + ');" title="Afficher le fond imagerie"></button>' +
                                '<p>Imagerie</p>' +
                            '</div>';

    var sobreSelectBtn = '<div class="BasemapToggle_selectBtnContainer">' +
                                '<span class="BasemapToggle_basemapTitle">Sobre</span>' +
                                '<button id="BasemapToggle_sobreBtn" class="BasemapToggle_selectBtn" style="background:url(' + sobre + ');" title="Afficher le fond sobre"></button>' +
                                '<p>Sobre</p>' +
                            '</div>';

    var chevronUp = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 28 28"><path stroke="rgb(75,75,75)" fill="rgb(75,75,75)" d="M26.297 20.797l-2.594 2.578c-0.391 0.391-1.016 0.391-1.406 0l-8.297-8.297-8.297 8.297c-0.391 0.391-1.016 0.391-1.406 0l-2.594-2.578c-0.391-0.391-0.391-1.031 0-1.422l11.594-11.578c0.391-0.391 1.016-0.391 1.406 0l11.594 11.578c0.391 0.391 0.391 1.031 0 1.422z"></path></svg>';
    var chevronDown = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 28 28"><path stroke="rgb(75,75,75)" fill="rgb(75,75,75)" d="M26.297 12.625l-11.594 11.578c-0.391 0.391-1.016 0.391-1.406 0l-11.594-11.578c-0.391-0.391-0.391-1.031 0-1.422l2.594-2.578c0.391-0.391 1.016-0.391 1.406 0l8.297 8.297 8.297-8.297c0.391-0.391 1.016-0.391 1.406 0l2.594 2.578c0.391 0.391 0.391 1.031 0 1.422z"></path></svg>';

    var basemapToggleContainerHtml = '<div>' +
                                        '<div id="BasemapToggle_firstBtnContainer"></div>' +
                                        '<div id="BasemapToggle_secondBtnContainer" style="display:none;"></div>' +
                                        '<div id="BasemapToggle_chevronContainer">' +
                                            '<span id="BasemapToggle_chevronUp" style="display:none;" title="Réduire">' + chevronUp + '</span>' +
                                            '<span id="BasemapToggle_chevronDown" title="Ouvrir"><p>Autres</p>' + chevronDown + '</span>' +
                                        '</div>' +
                                    '</div>';



    class BasemapItem {
      constructor(basemapConfig, selectBtn) {
        this._map = window.cartovista.externalInterface.map;
        this.id = basemapConfig.ID;
        this.basemapLayers = _.map(basemapConfig.BASEMAPLAYERS_IDS, this._getBasemapLayer.bind(this));
        this.initial = basemapConfig.INITIAL;
        this.copyrightsImagerie = basemapConfig.COPYRIGHTS_IMAGERIE;
        this.$firstSelectBtn = $(selectBtn).css("display", "none");
        this.$secondSelectBtn = $(selectBtn);

        this._selected = false;
        this._firstChoice = false;
        Object.defineProperties(this, {
            "selected": {
                get: function() { return this._selected; },
                set: function(bool) {
                    this._selected = bool;
                    _.forEach(this.basemapLayers, function(basemapLayer) { basemapLayer.visible = bool; });
                    if (bool) {
                        this.$secondSelectBtn.find(".BasemapToggle_selectBtn").addClass("selected");
                    } else {
                        this.$secondSelectBtn.find(".BasemapToggle_selectBtn").removeClass("selected");
                    }
                }
            },
            "firstChoice": {
                get: function() { return this._firstChoice; },
                set: function(bool) {
                    this.$firstSelectBtn.css("display", bool ? "" : "none");
                    this._firstChoice = bool;
                }
            }
        });
      }

      _getBasemapLayer(basemapLayerId) {
          var basemapLayer = this._map.getLayer(basemapLayerId);
          if (basemapLayer) {
              basemapLayer.visible = false;
              basemapLayer.activeTileProvider.copyrightNotice = "© Gouvernement du Québec";
              basemapLayer.activeTileProvider.termsOfUseURL = "";
              return basemapLayer;
          } else {
              throw new Error("BasemapItem._getBasemapLayer() - basemapLayerId: " + basemapLayerId + " is invalid.");
          }
      };
    }

    class BasemapStore {
      constructor(basemapsConfigs) {
        this.items = _.map(basemapsConfigs, this._createBasemapItem.bind(this));
        Object.defineProperties(this, {
            "selectedItem" : {
                get: function() { return _.find(this.items, "selected"); },
                set: function(selectedBasemapItem) {
                    var previousBasemapItem = this.selectedItem;
                    if (this.firstChoiceItem) {
                        this.firstChoiceItem.firstChoice = false;
                    }
                    if (previousBasemapItem) {
                        previousBasemapItem.firstChoice = true;
                        previousBasemapItem.selected = false;
                        if (selectedBasemapItem) {
                            selectedBasemapItem.selected = true;
                        }
                    } else {
                        if (selectedBasemapItem) {
                            selectedBasemapItem.selected = true;
                        }
                        //first unselected basemapItem become the firstChoice
                        _.find(this.items, ["selected", false]).firstChoice = true;
                    }
                    window.cartovista.dispatchEvent(new DBxEvent("BasemapStore_selectedItem_changed", selectedBasemapItem));
                }
            },
            "firstChoiceItem": {
                get: function() { return _.find(this.items, "firstChoice"); }
            }
        });
        this.selectedItem = _.find(this.items, "initial");
      }

      _createBasemapItem(basemapConfig) {
          switch (basemapConfig.ID) {
              case "carte":
                  return new BasemapItem(basemapConfig, carteSelectBtn);
              case "imagerie":
                  return new BasemapItem(basemapConfig, imagerieSelectBtn);
              case "sobre":
                  return new BasemapItem(basemapConfig, sobreSelectBtn);
              case "hybride":
                  return new BasemapItem(basemapConfig, hybridSelectBtn);
              default:
                  throw new Error("BasemapStore._createBasemapItem() - basemapConfig.ID: " + basemapConfig.ID + " is invalid.");
          };
      };
    }

    export default class BasemapToggle {
      constructor() {
        this._map = window.cartovista.externalInterface.map;
        this._mapController = window.cartovista.getMapController(this._map);
        this._basemapStore = new BasemapStore(C.MAP_TOOLS.BASEMAP_TOGGLE);
        this._$imagerieCopyrightsContainer = $(copyrightImagerieContainer);
        $("#Copyrights_container").append(this._$imagerieCopyrightsContainer);
        this._$container = $("#BasemapToggle_container");
        this._$toggleContainer = $(basemapToggleContainerHtml);
        this._$toggleContainer.on("click", ".BasemapToggle_selectBtn", this._onSelectBtnClicked.bind(this));
        this._$container.append(this._$toggleContainer);
        this._$firstBtnContainer = this._$toggleContainer.find("#BasemapToggle_firstBtnContainer");
        this._$secondBtnContainer = this._$toggleContainer.find("#BasemapToggle_secondBtnContainer");
        this._$firstBtnContainer.append(_.map(this._basemapStore.items, "$firstSelectBtn"));
        this._$secondBtnContainer.append(_.map(this._basemapStore.items, "$secondSelectBtn"));
        this._$chevronContainer = this._$toggleContainer.find("#BasemapToggle_chevronContainer");
        this._$chevronContainer.click(this._onChevronClicked.bind(this));
        this._updateThemesetsLayersSettings();
        this._map.addEventListener(this._map.EVENTS.EXTENT_CHANGED, _.debounce(this._displayImagerieCopyrights, 100).bind(this), this);
        window.cartovista.addEventListener("BasemapStore_selectedItem_changed", this._displayImagerieCopyrights.bind(this));
        this._$container.parent().mouseenter(function() { this._$container.removeClass("easeOut").addClass("easeIn"); }.bind(this));
        this._$container.parent().mouseleave(function() { this._$container.removeClass("easeIn").addClass("easeOut"); }.bind(this));
      }

    //to prevent the basemaps visibility to be changed when a themeSet is applied
    _updateThemesetsLayersSettings() {
        _.forEach(this._map.themeSetElementRoot.getThemeSetList(), function(themeSet) {
            _.remove(themeSet.themeSetMapSettings.themeSetLayerSettings, function(layerSetting) {
                return layerSetting.layer.layerType == "TILE";
            }.bind(this));
        }.bind(this));
    };

    _displayImagerieCopyrights() {
        if (this._basemapStore.selectedItem && this._basemapStore.selectedItem.copyrightsImagerie) {
            var copyrights = _.reduce(imagerieCopyrights, function(copyrights, cprObj) {
                if (cprObj.levelMin <= this._map._masterTileLayer.coordinate.zoom && cprObj.levelMax >= this._map._masterTileLayer.coordinate.zoom && this._map.extent.intersect(new Extent(cprObj.bbox.minX, cprObj.bbox.minY, cprObj.bbox.maxX, cprObj.bbox.maxY))) {
                    copyrights.push('&nbsp;|&nbsp;<span>' + cprObj.copyright + '</span>');
                }
                return copyrights;
            }.bind(this), []);
            this._$imagerieCopyrightsContainer.html(_.uniq(copyrights));
        } else {
            this._$imagerieCopyrightsContainer.empty();
        }
    };

    _onChevronClicked(evt) {
        this._$chevronContainer.find("#BasemapToggle_chevronUp").toggle();
        this._$chevronContainer.find("#BasemapToggle_chevronDown").toggle();
        this._$firstBtnContainer.toggle();
        this._$secondBtnContainer.toggle();
    };

    _onSelectBtnClicked(evt) {
        var selectedBasemapItem = _.find(this._basemapStore.items, function(basemapItem) {
            return basemapItem.$secondSelectBtn.find(".BasemapToggle_selectBtn").prop("id") == evt.target.id;
        });
        this._basemapStore.selectedItem = selectedBasemapItem != this._basemapStore.selectedItem ? selectedBasemapItem : null;
    };

  }
